import { render, staticRenderFns } from "./FormRelatorio.vue?vue&type=template&id=11a39326"
import script from "./FormRelatorio.vue?vue&type=script&lang=js"
export * from "./FormRelatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports